import { inject } from 'vue';
import { routerKey } from 'vue-router';

// Going back from a page a person reached from the app's shell.
//
// It asks the ROUTER what there is to pop, not the browser. vue-router records
// the previous entry in its own history state, which is empty exactly when
// there is nothing of the application's behind this page — a deep link, or an
// arrival by `router.replace`, as from the link-outcome acknowledgement. A bare
// `router.back()` would do nothing at all there, so the page goes to the app's
// front door instead and back never dead-ends.
//
// @hds/common-ui-lib holds the same few lines for its Settings page: this
// package's targets export screens, not helpers.
//
// The router is read with `inject` rather than `useRouter()`, which warns when
// there is none. A page shown on its own in a Storybook has none, and its back
// arrow then does nothing.
function useBackOrHome() {
    const router = inject(routerKey, null);
    return function goBack() {
        if (!router) {
            return;
        }
        if (router.options?.history?.state?.back) {
            router.back();
            return;
        }
        router.push('/');
    };
}

export { useBackOrHome };
